import React from 'react';
import MainEntrances from '../components/MainEntrances';

export default function MobileGames() {
  const entityType = 'mobile';

  return <MainEntrances entityType={entityType} />;
}
